import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PackagesService from "../../../../services/PackagesService";
import { Translate } from "../../../Enums/Tranlate";
import BaseService from "../../../../services/BaseService";
import LoaderImg from "../../../common/LoaderImg";
import Select from "react-select";
import VendorsService from "../../../../services/VendorsService";
// import { ContentState, EditorState, convertToRaw } from "draft-js";
// import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import "draft-js/dist/Draft.css";
// import { Editor } from "react-draft-wysiwyg";

const AddPackage = () => {
	const location = useLocation();
	const [formData, setFormData] = useState({
		name_en: "",
		name_ar: "",
		feature_en: "", //EditorState.createEmpty(),
		feature_ar: "", //EditorState.createEmpty(),
		vendor: "",
		add_additional_details: false,
		additional_details: [
			{
				name_en: "",
				name_ar: "",
				price: "",
			},
		],
		image: "",
		price: "",
	});
	const [vendorsOptions, setVendorsOptions] = useState([]);
	const [loadingImg, setLoadingImg] = useState(false);
	const navigate = useNavigate();
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const packagesService = new PackagesService();
	const vendorsService = new VendorsService();

	useEffect(() => {
		vendorsService.getList().then((res) => {
			if (res?.status) {
				let response = res?.data?.data?.data?.map((info) => {
					return {
						...info,
						label: info[`name_${lang}`],
						value: info?.id,
					};
				});
				setVendorsOptions(response);
			}
		});
	}, []);

	useEffect(() => {
		if (!location?.state) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			let state = location?.state;
			setFormData({
				id: state?.id,
				name_en: state?.name_en,
				name_ar: state?.name_ar,
				feature_en: state?.feature_en,
				// EditorState.createWithContent(
				// 	ContentState.createFromBlockArray(htmlToDraft(state?.feature_en))
				// ),
				feature_ar: state?.feature_ar,
				// EditorState.createWithContent(
				// 	ContentState.createFromBlockArray(htmlToDraft(state?.feature_ar))
				// ),
				price: state?.price,
				vendor: {
					...state.vender,
					label: state?.vender[`name_${lang}`],
					value: state?.vender?.id,
				},
				add_additional_details: !!state?.package_additional_details?.length,
				additional_details: !!state?.package_additional_details?.length
					? state?.package_additional_details?.map((res) => {
							return {
								name_en: res?.name_en,
								name_ar: res?.name_ar,
								price: res?.price,
							};
					  })
					: [
							{
								name_en: "",
								name_ar: "",
								price: "",
							},
					  ],
				image: state?.image,
			});
		}
	}, [location]);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.vendor || !formData?.image) {
			if (!formData?.vendor) toast.error("Select Vendor");
			if (!formData?.image) toast.error("Select Image");
			return;
		}

		let data = {
			name_en: formData?.name_en,
			name_ar: formData?.name_ar,
			feature_en: formData?.feature_en,
			// draftToHtml(
			// 	convertToRaw(formData?.feature_en.getCurrentContent())
			// ),
			feature_ar: formData?.feature_ar,
			// draftToHtml(
			// 	convertToRaw(formData?.feature_ar.getCurrentContent())
			// ),
			image: formData?.image,
			price: formData?.price,
			vender_id: formData?.vendor?.value,
		};
		if (formData?.add_additional_details) {
			data["package_additional_details"] = formData?.additional_details;
		} else {
			data["package_additional_details"] = [];
		}

		setLoading(true);
		if (isAdd) {
			packagesService.create(data)?.then((res) => {
				if (res?.status === 201) {
					toast.success(res?.data?.message);
					navigate("/packages");
				}
				setLoading(false);
			});
		} else {
			packagesService.update(formData?.id, data)?.then((res) => {
				if (res?.status === 200) {
					toast.success(res?.data?.message);
					navigate("/packages");
				}
				setLoading(false);
			});
		}
	};

	const fileHandler = (e) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!filesData?.length) {
			return;
		}
		setLoadingImg(true);
		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setFormData((prev) => ({ ...prev, image: res.data.url }));
			}
			setLoadingImg(false);
		});
	};

	const inputHandlerChange = (e) => {
		setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	return (
		<Row>
			<Col md={10}>
				<div
					className="d-flex align-items-center"
					style={{ gap: "8px", margin: "12px 0 32px" }}>
					<svg
						style={{ cursor: "pointer" }}
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						className="button-back"
						xmlns="http://www.w3.org/2000/svg"
						onClick={() => navigate("/packages")}>
						<path
							d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
							stroke="#1E1F24"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M20.4999 12H3.66992"
							stroke="#1E1F24"
							strokeWidth="1.5"
							strokeMiterlimit="10"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>

					<label
						className="mb-0"
						style={{ fontSize: "20px", fontWeight: "600" }}>
						{!isAdd ? Translate[lang]?.edit : Translate[lang]?.add}{" "}
						{Translate[lang]?.package}
					</label>

					{/* {!isAdd && (
						<Form.Check
							type="switch"
							id="custom-switch"
							checked={formData?.status}
							onChange={(e) =>
								setFormData((prev) => ({ ...prev, status: e.target.checked }))
							}
						/>
					)} */}
				</div>
				<AvForm className="form-horizontal" onValidSubmit={submit}>
					<Row>
						{/* Name En */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name} ({Translate[lang]?.english})
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_en}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* Name Ar */}
						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.name} ({Translate[lang]?.arabic})
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name_ar"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name_ar}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* Features En */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.features} ({Translate[lang]?.english})
							</label>
							<div className="editorField">
								<AvField
									type="textarea"
									placeholder={Translate[lang]?.english}
									bsSize="lg"
									style={{
										height: "150px",
									}}
									name="feature_en"
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.feature_en}
									onChange={(e) => inputHandlerChange(e)}
								/>

								{/* <Editor
									editorState={formData.feature_en}
									toolbarClassName="toolbarClassName"
									wrapperClassName="wrapperClassName"
									editorClassName="editorClassName"
									onEditorStateChange={(e) => {
										setFormData((prev) => ({ ...prev, feature_en: e }));
									}}
								/> */}
							</div>
						</Col>
						{/* Features Ar */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.features} ({Translate[lang]?.arabic})
							</label>
							<div className="editorField">
								<AvField
									type="textarea"
									placeholder={Translate[lang]?.features}
									bsSize="lg"
									name="feature_ar"
									style={{
										height: "150px",
									}}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={formData.feature_ar}
									onChange={(e) => inputHandlerChange(e)}
								/>

								{/* <Editor
									editorState={formData.feature_ar}
									toolbarClassName="toolbarClassName"
									wrapperClassName="wrapperClassName"
									editorClassName="editorClassName"
									onEditorStateChange={(e) => {
										setFormData((prev) => ({ ...prev, feature_ar: e }));
									}}
								/> */}
							</div>
						</Col>
						{/* Price */}
						<Col md={6}>
							<label>{Translate[lang]?.price}</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.price}
								bsSize="lg"
								name="price"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.price}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* Vendor */}
						<Col md={6} className="mb-3">
							<label className="text-label">{Translate[lang]?.vendor}</label>
							<Select
								placeholder={Translate[lang]?.select}
								bsSize="lg"
								options={vendorsOptions}
								name="vendor"
								value={formData.vendor}
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, vendor: e }))
								}
							/>
						</Col>
						{/* Image */}
						<Col md={6} className="mb-4">
							<label className="text-label mb-0">{Translate[lang].image}</label>
							<div className="upload">
								<input
									type="file"
									name="image"
									id="image"
									onChange={(e) => fileHandler(e)}
								/>
								<p>{Translate[lang].upload_image}</p>
								{loadingImg ? (
									<LoaderImg />
								) : !formData?.image ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							{!!formData?.image && (
								<img
									src={formData?.image}
									alt="category"
									width={80}
									className="mt-3"
								/>
							)}
						</Col>
						{/* Add Additional Details */}
						<Col md={12}>
							<Form.Label className="d-flex gap-16 cursor-pointer text-label mb-0">
								<Form.Check
									type="switch"
									id="add_additional_details-switch"
									checked={formData?.add_additional_details}
									onChange={(e) =>
										setFormData((prev) => ({
											...prev,
											add_additional_details: e.target.checked,
										}))
									}
								/>
								{Translate[lang].add_additional_details}
							</Form.Label>
						</Col>
					</Row>
					{formData?.add_additional_details && (
						<div className="mt-4 table-style p-3">
							{formData?.additional_details?.map((addDetails, index) => {
								return (
									<Row key={index} style={{ borderBottom: "1px solid #eee" }}>
										{index > 0 && (
											<Col
												md={12}
												className="d-flex justify-content-end mt-1 mb-1 pt-2">
												<i
													onClick={() =>
														setFormData((prev) => ({
															...prev,
															additional_details:
																prev.additional_details?.filter(
																	(_, ind) => index !== ind
																),
														}))
													}
													className="la la-times-circle text-danger fs-24 cursor-pointer"
												/>
											</Col>
										)}
										{/* Name En */}
										<Col md={4}>
											<label className="text-label">
												{Translate[lang]?.name} ({Translate[lang]?.english})
											</label>
											<AvField
												type="text"
												placeholder={Translate[lang]?.name}
												bsSize="lg"
												name={`name_en${index}`}
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={addDetails.name_en}
												onChange={(e) =>
													setFormData((prev) => ({
														...prev,
														additional_details: prev?.additional_details?.map(
															(res, ind) =>
																ind === index
																	? { ...res, name_en: e.target.value }
																	: res
														),
													}))
												}
											/>
										</Col>
										{/* Name Ar */}
										<Col md={4}>
											<label className="text-label">
												{Translate[lang]?.name} ({Translate[lang]?.arabic})
											</label>
											<AvField
												type="text"
												placeholder={Translate[lang]?.name}
												bsSize="lg"
												name={`name_ar${index}`}
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={addDetails.name_ar}
												onChange={(e) =>
													setFormData((prev) => ({
														...prev,
														additional_details: prev?.additional_details?.map(
															(res, ind) =>
																ind === index
																	? { ...res, name_ar: e.target.value }
																	: res
														),
													}))
												}
											/>
										</Col>
										{/* Price */}
										<Col md={4}>
											<label>{Translate[lang]?.price}</label>
											<AvField
												type="number"
												placeholder={Translate[lang]?.price}
												bsSize="lg"
												name={`price${index}`}
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={addDetails.price}
												onChange={(e) =>
													setFormData((prev) => ({
														...prev,
														additional_details: prev?.additional_details?.map(
															(res, ind) =>
																ind === index
																	? { ...res, price: e.target.value }
																	: res
														),
													}))
												}
											/>
										</Col>
									</Row>
								);
							})}
							<Button
								variant="outline-primary"
								type="button"
								className="mt-2"
								onClick={() =>
									setFormData((prev) => ({
										...prev,
										additional_details: [
											...prev?.additional_details,
											{ name_en: "", name_ar: "", price: "" },
										],
									}))
								}
								disabled={loading}>
								{Translate[lang]?.add_new_value}
							</Button>
						</div>
					)}
					<Row>
						<Col md={6} className="mt-4">
							<Button
								variant="primary"
								type="submit"
								className="w-100"
								disabled={loading}>
								{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
								{Translate[lang]?.package}
							</Button>
						</Col>
					</Row>
				</AvForm>
			</Col>
		</Row>
	);
};

export default AddPackage;
